import { Box, Stack } from "@mui/material";
import { type ReactNode } from "react";
import Logo from "./Logo";
import {globalStyles} from "../styles/global.styles";

export default function Global({ children }: { children: ReactNode }) {
  return (
    <Box
      sx={globalStyles.global.boxOuterContainer}
    >
      <Box
        sx={globalStyles.global.boxInnerContainer}
      >
        <Stack spacing={2} alignItems="center" sx={{ pt: 2 }}>
          <Box
            component={Logo}
            sx={globalStyles.global.boxInnerContainerStackBox}
          />
          {children}
        </Stack>
      </Box>
    </Box>
  );
}
